export default __webpack_public_path__ + "static/media/loader.b07ffd7e.svg";